/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { getAuth } from "firebase/auth";
import { getFirestore, getDoc, doc } from "firebase/firestore";
import { store } from "@/store";
import { UserStore } from "@/store/constants";

export const useAuthService = async (): Promise<null | void> => {
  if (store.getters[UserStore.Getters.IS_SIGNED_IN]) return;
  let interval: NodeJS.Timer;
  await new Promise((resolve) => {
    getAuth().onAuthStateChanged(async (user) => {
      if (user) {
        store.commit(UserStore.Mutations.SIGN_IN, user);
        const idToken = await user.getIdToken(true);
        store.commit(UserStore.Mutations.SET_ID_TOKEN, idToken);
        interval = setInterval(async () => {
          const idToken = await user.getIdToken(true);
          store.commit(UserStore.Mutations.SET_ID_TOKEN, idToken);
        }, 1000 * 60 * 15);
        const userDoc = await getDoc(doc(getFirestore(), "users/" + user.uid));
        const orgId = userDoc.data()?.root_organization;
        if (orgId) store.commit(UserStore.Mutations.SET_ORGANIZATION, orgId);
        resolve(null);
      } else {
        await store.dispatch(UserStore.Actions.SIGN_OUT);
        resolve(null);
      }
    });
  });
};

export const signOut = async (): Promise<void> => {
  await getAuth().signOut();
};
